import React, { ChangeEvent, MouseEvent, useState } from 'react';
import { Card } from './Card';
import { Sales } from '../../model/ProductSales';
import { List, ProductSalesListMode } from '../productSales/List';
import { Earnings } from '../productSales/Earnings';
import { Units } from '../productSales/Units';
import { Information } from '../Information';
import { ComparePreset } from '../../model/datePicker/types';
import { t } from '../../i18n';

const ProductSalesCard = ({ sales, previousSales, comparePreset }: Props) => {
  const [filter, setFilter] = useState('');
  const [listMode, setListMode] = useState<ProductSalesListMode>('family');

  const onChangeFilter = (event: ChangeEvent<HTMLInputElement>) => {
    setFilter(event.target.value);
  }

  const onChangeListMode = (event: MouseEvent<HTMLButtonElement>) => {
    setListMode(event.currentTarget.value as ProductSalesListMode);
  }

  const amount = listMode === 'product' ? sales.productSalesAmount : listMode === 'brand' ? sales.brandSalesAmount : sales.familySalesAmount;
  const previousAmount = listMode === 'product' ? previousSales.productSalesAmount : listMode === 'brand' ? previousSales.brandSalesAmount : previousSales.familySalesAmount;
  const units = listMode === 'product' ? sales.productSalesUnits : listMode === 'brand' ? sales.brandSalesUnits : sales.familySalesUnits;
  const previousUnits = listMode === 'product' ? previousSales.productSalesUnits : listMode === 'brand' ? previousSales.brandSalesUnits : previousSales.familySalesUnits;
  const items = listMode === 'product' ? sales.productSales : listMode === 'brand' ? sales.brandSales : sales.familySales;
  const previousItems = listMode === 'product' ? previousSales.productSales : listMode === 'brand' ? previousSales.brandSales : previousSales.familySales;

  return (
    <Card className="media-playback">
      <div className="card-body">
        <div className="card-title pb-3 mb-3 border-bottom d-flex align-items-center justify-content-between">
          <h5 className="w-100 mb-4">
            <Information id="salesAndEarnings" content={<span className="me-2">{t('productSales.title')}</span>} />
            <Information id="salesAndEarnings" showMore={true} />
          </h5>
          <div className="d-flex align-items-center">
            <div className="d-flex align-items-center gap-3 me-5">
              <button
                type="button"
                className={`btn pill shadow-none border-0 px-4 ${listMode === 'family' ? 'active' : ''}`}
                value="family"
                aria-pressed={listMode === 'family'}
                onClick={onChangeListMode}
                style={{ backgroundColor: listMode === 'family' ? '#f1f1f3' : 'transparent' }}
              >
                {t('productSales.family')}
              </button>
              <button
                type="button"
                className={`btn pill shadow-none border-0 px-4 ${listMode === 'product' ? 'active' : ''}`}
                value="product"
                aria-pressed={listMode === 'product'}
                onClick={onChangeListMode}
                style={{ backgroundColor: listMode === 'product' ? '#f1f1f3' : 'transparent' }}
              >
                {t('productSales.product')}
              </button>
              <button
                type="button"
                className={`btn pill shadow-none border-0 px-4 ${listMode === 'brand' ? 'active' : ''}`}
                value="brand"
                aria-pressed={listMode === 'brand'}
                onClick={onChangeListMode}
                style={{ backgroundColor: listMode === 'brand' ? '#f1f1f3' : 'transparent' }}
              >
                {t('productSales.brand')}
              </button>
            </div>
            <div style={{ width: 200 }}>
              <div className="input-group input-group-merge">
                <span className="input-group-text">
                  <i className="ti ti-search" />
                </span>
                <input type="text" className="form-control form-control-sm" placeholder={t('common.search')} onChange={onChangeFilter} />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-start flex-wrap" style={{ height: 115 }}>
          <div className="d-flex align-items-center me-5">
            <Earnings value={amount} previousValue={previousAmount} comparePreset={comparePreset} />
          </div>
          <div className="d-flex align-items-center">
            <Units value={units} previousValue={previousUnits} comparePreset={comparePreset} />
          </div>
        </div>
        <div className="mt-4">
          <List items={items} previousItems={previousItems} filter={filter} mode={listMode} />
        </div>
      </div>
    </Card>
  );
}

interface Props {
  sales: Sales,
  previousSales: Sales,
  comparePreset?: ComparePreset
}

export { ProductSalesCard };
